import React, { useContext, useState } from "react";
import { Form, Icon, Input, Button, Layout, Row, Col, Alert, Spin } from "antd";
import { AuthContext } from "../../App";
import  { authenticationService } from "../../services/authentication.service";

//Components
import SelectLanguage from "../../components/select-language";
import { useTranslation } from 'react-i18next'
import logoCeit from "./../../assets/img/ceit.png";

const { Header, Content, Footer } = Layout;

const Login = () => {
  const { dispatch } = useContext(AuthContext);
  const initialState = {
    name: "",
    password: "",
    isSubmitting: false,
    errorMessage: null
  };

  const [data, setData] = useState(initialState);
  
  //To translate text
  const { t } = useTranslation();

  const handleInputChange = event => {
    setData({
      ...data,
      [event.target.name]: event.target.value
    });
  };

  const handleFormSubmit = event => {
    event.preventDefault();

    setData({
      ...data,
      isSubmitting: true,
      errorMessage: null
    });

    let user_data = authenticationService.login(data.username, data.password)

    if (user_data) {
      dispatch({
        type: "LOGIN",
        payload: { user: user_data }
      });
    } else {
      setData({
        ...data,
        isSubmitting: false,
        errorMessage: t('login.error_msg')
      });
    }
  };

  return (
    <div>
      <Layout className="layout" style={{ minHeight: "100vh", background: "#fff" }}>
        <Header className="header-login" style={{ padding: 0 }}></Header>
        <Content>
          <Row style={{ background: "#fff", minHeight: "calc(100vh - 140px)" }} type="flex" justify="space-around" align="middle">
            <Col sm={24} md={12} lg={6} xl={6} style={{ textAlign: "center" }}>
              <Form onSubmit={handleFormSubmit} className="login-form" style={{ padding: 24 }}>
                <img src={logoCeit} alt="Logo" style={{ height: "15vh", marginBottom: "20px" }} />

                <Form.Item>
                  <SelectLanguage />
                </Form.Item>
                
                <Form.Item>
                  <Input
                    prefix={<Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />}
                    placeholder={t('login.user')}
                    name="username"
                    onChange={handleInputChange}
                  />
                </Form.Item>
                <Form.Item>
                  <Input
                    prefix={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />}
                    type="password"
                    placeholder={t('login.password')}
                    name="password"
                    onChange={handleInputChange}
                  />
                </Form.Item>
                <Form.Item>
                  <Spin spinning={data.isSubmitting}>
                    <Button type="primary" htmlType="submit" className="login-form-button">
                      {t('login.get_in')}
                    </Button>
                  </Spin>
                  {data.errorMessage && <Alert message={data.errorMessage} type="error" showIcon />}
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </Content>
        <Footer style={{ textAlign: "center" }}>{t('login.footer_text')}</Footer>
      </Layout>
    </div>
  );
};

export default Login;
